import { StageDataField } from '@Components/Flows';
import { useGetPurchase } from '../../../hooks/usePurchases';
import { formatCurrency, formatDateWithTime } from '@Utils/utils';

const discountTypeObj = {
  PERCENTAGE: '%',
  FLATAMOUNT: 'off',
  PRICEOVERRIDE: 'Price Override',
};

export function StageContentPDDeposit({ stage }) {
  const purchaseId = stage?.result?.responseDataBindings?.[0];

  const { data: purchase } = useGetPurchase(purchaseId, {
    include: 'eventType,venue,status,spaces',
  });

  const event = purchase?.event ? purchase.event : null;
  const venue = event && event.venue ? event.venue : null;

  const eventName = event?.name ?? 'N/A';
  const eventStartDate = formatDateWithTime(event?.startDate) ?? 'N/A';
  const eventEndDate = formatDateWithTime(event?.endDate) ?? 'N/A';
  const eventGuestCount = event?.guestCount?.toString() ?? 'N/A';
  const eventExternalEventId = event?.externalEventId ?? 'N/A';
  const eventAdditionalNotes = event?.additionalNotes ?? 'N/A';

  const venueName = venue?.name ?? 'N/A';
  const venueDescription = venue?.description ?? 'N/A';

  const eventStatus = event?.status ? event.status.name : 'N/A';

  const purchaseProductDescription = purchase?.productDescription ?? 'N/A';
  const purchaseCreatedAt = formatDateWithTime(purchase?.createdAt) ?? 'N/A';
  const purchaseConfirmationNumber = purchase?.confirmationNumber ?? 'N/A';
  const purchaseOriginalPrice = formatCurrency(purchase?.originalPrice) ?? 'N/A';
  const purchaseDiscountAmount = formatCurrency(purchase?.discountAmount) ?? null;
  const purchaseDiscountType = purchase?.discountType ?? null;
  const purchasePrice = formatCurrency(purchase?.price) ?? 'N/A';

  const discount =
    purchaseDiscountAmount && purchaseDiscountType
      ? `${purchaseDiscountAmount} ${discountTypeObj[purchaseDiscountType]}`
      : 'N/A';

  return (
    <div className="flex flex-col gap-3">
      <div className="break-word w-1/2">
        <StageDataField label={'Event Name'} value={eventStatus} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event Status'} value={eventName} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Start Date'} value={eventStartDate} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'End Date'} value={eventEndDate} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Guest Count'} value={eventGuestCount} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'External Event Id'}
          value={eventExternalEventId}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Additional Notes'}
          value={eventAdditionalNotes}
        />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField label={'Venue Name'} value={venueName} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Venue Description'} value={venueDescription} />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Description'}
          value={purchaseProductDescription}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Purchase Date'} value={purchaseCreatedAt} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Confirmation Number'}
          value={purchaseConfirmationNumber}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Original Price'}
          value={purchaseOriginalPrice}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Discount'} value={discount} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Purchase Price'} value={purchasePrice} />
      </div>
    </div>
  );
}
